module.exports = __webpack_public_path__ + "static/media/warning-blue.f4910d22.svg";